import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, remove, scrollInfo } from 'kapix-components-vue3'
import hubExpertRessourcesStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'hubExpertRessources'
const customImplement: CustomStoreImplementationOptions = hubExpertRessourcesStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function hubExpertRessourcesFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('ressources-expert.title', 'Ressources | Expert'),
        $description: $translate('ressources-expert.description', ''),
        $publishedTime: new Date('2023-02-13T07:42:17.661Z'),
        $modifiedTime: new Date('2023-09-14T10:32:16.788Z'),
        // Constants,
        $constants: {},
        // Data,
        $info: { ressourcesExpert: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async consulterGtClick () {
        await navigateTo({ name: 'hub-expert-Ressources-preparer-rdv-decouverte' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async ressource1Click () {
        await navigateTo({ name: 'hub-expert-Ressources-preparer-rdv-decouverte' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text1Click () {
        await navigateTo({ name: 'hub-expert-Ressources-rediger-programme-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async ressource2Click () {
        await navigateTo({ name: 'hub-expert-Ressources-rediger-programme-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text2Click () {
        await navigateTo({ name: 'hub-expert-Ressources-construire-support-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async ressource3Click () {
        await navigateTo({ name: 'hub-expert-Ressources-construire-support-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async blocPreviewRessourceHubRessourcesClick () {
        await navigateTo({ name: 'Expert-Ressources-organiser-sa-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element1Click () {
        await navigateTo({ name: 'Expert-Ressources-animer-la-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element3Click () {
        await navigateTo({ name: 'Expert-Ressources-Evaluations' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return hubExpertRessourcesFactory(storeId)()
}

export const hubExpertRessourcesRaw = hubExpertRessourcesFactory()
export const hubExpertRessources = () => hubExpertRessourcesRaw() as MergeCustomStore<typeof hubExpertRessourcesStoreCustom.instance>
